<template>
  <div class="vx-row">
    <div class="vx-card__collapsible-content vs-con-loading__container W-1/6">
      <div class="vx-card__body custom-tbl v-table">
        <vs-table :data="attachmets" ref="orderTable">
          <template :name="{ data }" slot-scope="{ data }">
            <vs-tr v-for="i in attachmets" :key="i.id">
              <vs-td class="w-1/2">
                {{ $t("Attachment") }}
                {{ i.type == 2 ? "فایل اکسل" : "تصویر" }}
              </vs-td>
              <vs-td class="w-1/2">
                <vs-button
                  v-if="i.type == 2"
                  type="filled"
                  class="float-right"
                  id="reset-btn"
                  :href="defaultUrl + i.uri"
                  >{{ $t("DownloadExcelFile") }}</vs-button
                >
                <vs-button
                  v-else
                  type="filled"
                  class="float-right"
                  id="reset-btn"
                  @click.prevent="showImg(i)"
                  >{{ $t("Show") }}</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      defaultUrl: URLS_CONSTANTS.assets + "Baskets/",
      attachmets: [],
      ImagePopup: false,
      modelForShowDetials:{}
    };
  },
  props: {
    basketId: ""
  },
  methods: {
    ...mapActions({
      fetchSaleAgentBasketImages: "basket/fetchSaleAgentBasketImages"
    }),
    showImg(i) {
      this.ImagePopup = true;
      this.modelForShowDetials={
        url:this.defaultUrl+i.uri,
        isShow:this.ImagePopup
      }
      
      this.$emit("showDetials", this.modelForShowDetials);
    }
  },
  mounted() {
    this.fetchSaleAgentBasketImages(this.basketId).then(r => {
      r.forEach(element => {
        this.attachmets.push({
          name: element.name,
          uri: element.uri,
          type: element.name.split(".")[1] == "xlsx" ? "2" : "1"
        });
      });
    });
  }
};
</script>

<style></style>
